import { Button, Input } from "@atoms";
import { provinceOptions, countryOptions } from "../profile/location-data";
import { FormEvent } from "react";
import { AuthSection } from "@organisms";
import { useTranslation } from "react-i18next";

export interface FormValues {
  street: string;
  city: string;
  country: string;
  province: string;
  postalCode: string;
}

export interface FormErrorValues {
  street: string | undefined;
  city: string | undefined;
  country: string | undefined;
  province: string | undefined;
  postalCode: string | undefined;
}

export type OnboardingAddressTemplateProps = {
  values: FormValues;
  errors: any;
  handleSubmit: (e?: FormEvent<HTMLFormElement> | undefined) => void;
  province: string;
  country: string;
  handleInputChangeAddress: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInputChangeProvince: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInputChangeCountry: (e: React.ChangeEvent<HTMLInputElement>) => void;
  logo: string;
  setLogo: (logo: string) => void;
  isLoading: boolean;
}
export const OnboardingAddressTemplate = ({
  values,
  errors,
  handleSubmit,
  province,
  country,
  handleInputChangeAddress,
  handleInputChangeProvince,
  handleInputChangeCountry,
  logo,
  setLogo,
  isLoading,
}: OnboardingAddressTemplateProps) => {
  const { t } = useTranslation();
  const fixedCountry = "CA";
  const stateProvinceOptions = provinceOptions.CA;
  return (
    <div className="min-h-screen flex">
      <AuthSection />
      {/* Right side - Form */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md px-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              {t("onboardingAddress.title")}
            </h1>
            <p className="text-gray-600 text-lg">
              {t("onboardingAddress.subtitle")}
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* <ImageUploader /> */}
            <Input
              variant="text"
              name="street"
              onChange={handleInputChangeAddress}
              placeholder={t("onboardingAddress.fields.street")}
              value={values.street}
              errorMessage={errors.street}
            />
            <Input
              variant="text"
              name="city"
              onChange={handleInputChangeAddress}
              placeholder={t("onboardingAddress.fields.city")}
              value={values.city}
              errorMessage={errors.city}
            />
            <Input
              type="provinceDropdown"
              variant="dropdown"
              name="province"
              options={stateProvinceOptions}
              onChange={handleInputChangeProvince}
              placeholder={t("onboardingAddress.fields.province")}
              value={province}
              errorMessage={errors.province}
            />
            <Input
              variant="text"
              name="country"
              onChange={() => {}}
              placeholder={t("onboardingAddress.fields.country")}
              value={fixedCountry}
              errorMessage={errors.country}
              disabled
            />
            <Input
              variant="text"
              name="postalCode"
              onChange={handleInputChangeAddress}
              placeholder={t("onboardingAddress.fields.postalCode")}
              value={values.postalCode}
              errorMessage={errors.postalCode}
            />
            <Button
              variant="primary"
              label={t("common.continue")}
              color="primary-medium"
              hoverColor="primary-dark"
              textColor="white"
              stretch
              type="submit"
              loading={isLoading}
            />
          </form>
        </div>
      </div>
    </div>
  );
}; 
